module.exports = __webpack_public_path__ + "img/done.6b004416.svg";